export default import.meta.ROLLDOWN_FILE_URL_VRAku6fjghkApIISiBWPzg_66873e48a21da1c19606af8a